import { useRequestMutation } from "hooks/useRequest";
import { Chat, History } from "models/AiResearch";

export const useHistoryUpdate = ({
  replaceHistory,
  setResult
}: {
  replaceHistory: (history: History[]) => void;
  setResult: React.Dispatch<React.SetStateAction<Chat>>;
}) => {
  const { trigger } = useRequestMutation<
    {
      historys: History[];
    },
    {
      talkId: string;
      title: string;
    }
  >("/sse/query/rag/history-update", "POST", {
    onSuccess: data => {
      replaceHistory(data.historys ?? []);
    }
  });

  const updateHistory = async (params: { talkId: string; title: string }) => {
    await trigger(params);
    setResult(prev => {
      return {
        ...prev,
        title: prev.talkId === params.talkId ? params.title : prev.title
      };
    });
  };

  return { updateHistory: updateHistory };
};
